import { buildUri } from "../../utils/dom";

export class AvailabilitySlotService {

    #timeSlots = [];


    get uri() {
        return buildUri(v24Scheduler.serviceRegion, `/api/scheduler/AvailabilitySlots`);
    }

    get timeSlots() {
        if(this.#timeSlots?.length === 0) {
            return;
        } 
        return this.#timeSlots;
    }

    async getTimeSlots(sitename, appointmentDate, appointmentType, locationId, clientOffset) {
        const params = new URLSearchParams();

        if(!sitename) {
            console.error("No site defined");
            return;
        }
        if(!appointmentDate) {
            console.error("No selected date defined");
            return;
        }
        if(!appointmentType) {
            console.error("No selected appointment id defined");
            return;
        }    

        params.append("sitename", sitename);
        params.append("appointmentDate", appointmentDate);
        params.append("appointmentTypeId", appointmentType);
        params.append("clientOffset", clientOffset);
        
        if(locationId) {
            params.append("locationId", locationId);
        }

        //TODO: ADD IN OPTIONAL PARAMS - RDM-8185
        // const locationId = options.locationId || "";
        const uri = `${this.uri}?${params.toString()}`;
        try {
            this.#timeSlots =
                await fetch(uri)
                    .then(response => response.json());
        } catch (e) {
            return false;
        }

        this.#timeSlots = this.#timeSlots.timeslots;
        return true;
    }


    async getNextAvailableDate(sitename, appointmentType, locationId, clientOffset) {
        const params = new URLSearchParams();

        if(!sitename) {
            console.error("No site defined");
            return;
        }

        if(!appointmentType) {
            console.error("No selected appointment id defined");
            return;
        }

        params.append("sitename", sitename);
        params.append("appointmentTypeId", appointmentType);
        params.append("clientOffset", clientOffset);
       
        if(locationId) {
            params.append("locationId", locationId);
        }

        const uri = `${this.uri}/GetNextAvailableDate?${params.toString()}`;
        return await fetch(uri)
        .then(response => response.json());
    }

}